// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1T5S9","location":"Header_location__3XkI5"};